// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XYSz","content":"styles_content__Kisjv","row":"styles_row__37htx","footer":"styles_footer__kfVbA","phraseLength":"styles_phraseLength__3-p9a"};